<template>
  <div class="home">
    <SectionHero />
    <SectionFeatures />
    <SectionShop />
    <SectionHowto />
    <SectionPickup />
    <SectionGuide />
    <SectionCta />
    <SectionFooter />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SectionHero from '@/components/sections/SectionHero.vue';
import SectionFeatures from '@/components/sections/SectionFeatures.vue';
import SectionShop from '@/components/sections/SectionShop.vue';
import SectionHowto from '@/components/sections/SectionHowto.vue';
import SectionPickup from '@/components/sections/SectionPickup.vue';
import SectionGuide from '@/components/sections/SectionGuide.vue';
import SectionCta from '@/components/sections/SectionCta.vue';
import SectionFooter from '@/components/sections/SectionFooter.vue';

export default {
  name: 'Home',
  components: {
    SectionHero,
    SectionFeatures,
    SectionShop,
    SectionHowto,
    SectionPickup,
    SectionGuide,
    SectionCta,
    SectionFooter,
  },
  computed: {
    ...mapState(['user', 'page', 'helper']),
  },
  mounted() {
    // スクロール連動アニメーション: IntersectionObserverで.fade-in-up要素を監視
    this.setupScrollAnimation();
  },
  beforeUnmount() {
    // オブザーバーのクリーンアップ
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    /** スクロールアニメーションのセットアップ */
    setupScrollAnimation() {
      const options = {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.1,
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // 一度表示したら監視を解除
            this.observer.unobserve(entry.target);
          }
        });
      }, options);

      // .fade-in-up クラスを持つ全要素を監視対象に追加
      this.$nextTick(() => {
        const targets = this.$el.querySelectorAll('.fade-in-up');
        targets.forEach((target) => {
          this.observer.observe(target);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
}
</style>
